'use client'

import type { ResolvedHeroBanner } from '@/helpers/cms/contentTypes'

import HeroBannerCarousel from './HeroBannerCarousel'
import useHeroBannerData from './useHeroBannerData'

const HeroBannerClient = ({
  cmsBanners,
  hiddenBundledBannerLinks,
}: {
  /**
   * CMS banners when the marketplace-content flag is on and at least one is live. Resolved on
   * the server because the images are Payload media relations and the LaunchDarkly gate on each
   * banner is evaluated there.
   */
  cmsBanners?: ResolvedHeroBanner[] | null
  /** Which bundled banner links go to a hidden storefront; see `BUNDLED_BANNER_STOREFRONT_LINKS`. */
  hiddenBundledBannerLinks?: string[]
}) => {
  const { banners } = useHeroBannerData(cmsBanners, hiddenBundledBannerLinks)

  return <HeroBannerCarousel banners={banners} />
}

export default HeroBannerClient
